import { render, staticRenderFns } from "./SpeakerList.vue?vue&type=template&id=876ff684&scoped=true"
import script from "./SpeakerList.vue?vue&type=script&lang=js"
export * from "./SpeakerList.vue?vue&type=script&lang=js"
import style0 from "./SpeakerList.vue?vue&type=style&index=0&id=876ff684&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "876ff684",
  null
  
)

export default component.exports